var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"journey"},[(_vm.isTargetView)?_c('ba-targeting'):_c('ba-pane')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }